<template>

<app-page :title="title" back="Dashboard" :is-loading="is.loading">

    <app-section>

        <app-panel title="Organisation" :is-padded="true">

            <app-input type="text" label="Name" placeholder="Enter name" v-model="model.name" />

        </app-panel>

        <app-actions>

            <app-button text="Save" :is-disabled="!canSave" :is-loading="is.saving" v-on:click.native="onSaveClick" />
            <app-button text="Delete" v-if="canDelete" :is-loading="is.deleting" theme="red" v-on:click.native="onDeleteClick" />

        </app-actions>

    </app-section>

    <com-collection v-if="!isNew" />

</app-page>

</template>

<script>

import comCollection from './organisation/Collection'

import mixForm from '@/mixin/form'
import { required } from 'vuelidate/lib/validators'

export default {

    mixins: [mixForm],

    components: {
        'com-collection': comCollection
    },

    data: function() {

        return {
            api: 'organisations',
            redirect: {
                new: 'Dashboard',
                delete: 'Dashboard'
            }
        }
    
    },

    validations: {
        model: {
            name: { required }
        }
    },

    computed: {
    
        title: function() {

            return (this.isNew) ? 'Create Organisation' : 'Edit Organisation'
        
        }
    
    }

}

</script>

<style scoped>

</style>
